const container = "_35sc1drr7fm";

export { container };
import "./readonly.richtext.style.linaria.module.css";
//# sourceMappingURL=readonly.richtext.style.js.map
